<template>
<v-card>
  <v-card-title class='subheading' >
    {{invoice.title}}
    <v-chip small>{{invoice.status}}</v-chip>
    <v-spacer></v-spacer>
    <span class='pr-4' >
      {{formatCurrency(invoice.currency, invoice.invoice_amount)}}
    </span>
  </v-card-title>
  <v-divider></v-divider>
  <v-list two-line >

    <v-list-tile >
      <v-list-tile-content>
        <v-list-tile-title>Invoice date: {{invoice.date}}</v-list-tile-title>
        <v-list-tile-sub-title>
          Due date: {{invoice.due_date}}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider></v-divider>

    <v-list-group v-if='invoice.context' >
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title>My info</v-list-tile-title>
          <v-list-tile-sub-title>
            Address, banking details, practice name and number
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile >
        <v-list-tile-content>
          <v-list-tile-title>Practice: {{invoice.context.practice_name}}</v-list-tile-title>
          <v-list-tile-sub-title>
            Number: {{invoice.context.practice_number}}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile >
        <v-list-tile-content>
          <v-list-tile-title>Contact details</v-list-tile-title>
          <v-list-tile-sub-title>
            {{invoice.invoicee_details || invoice.context.from_string}}
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon><v-icon>edit</v-icon></v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile >
        <v-list-tile-content>
          <v-list-tile-title>Banking details</v-list-tile-title>
          <v-list-tile-sub-title>
            {{invoice.context.banking_details}}
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon><v-icon>edit</v-icon></v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list-group>
    <v-divider></v-divider>

    <!-- billing info -->
    <v-list-group v-if='invoice.context' >
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title>Customer billing info</v-list-tile-title>
          <v-list-tile-sub-title>
            Bill to, medical aid info
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile>
        <v-list-tile-content >
          <v-list-tile-title >Bill to</v-list-tile-title>
          <v-list-tile-sub-title >{{invoice.context.customer_info}}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon><v-icon>edit</v-icon></v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile>
        <v-list-tile-content >
          <v-list-tile-title >Medical Aid info</v-list-tile-title>
          <v-list-tile-sub-title >{{invoice.context.medicalaid_info}}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon><v-icon>edit</v-icon></v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider></v-divider>
    </v-list-group>

    <v-list-group v-if='invoice.context' >
      <v-subheader slot='activator' >Line items</v-subheader>
      <template v-for='appointment in invoice.context.appointments' >
        <v-divider :key='`${appointment.id}-d`' ></v-divider>
        <v-list-tile :key='appointment.id' >
          <v-list-tile-content>
            <v-list-tile-title>
              {{appointment.invoice_title || appointment.full_name}}
            </v-list-tile-title>
            <v-list-tile-sub-title >
              {{dateformat(appointment.start_time)}}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            {{ formatCurrency(invoice.currency, appointment.price) }}
          </v-list-tile-action>
        </v-list-tile>
        <template v-if="appointment.codes && appointment.codes.length > 0" >
          <v-subheader :key='`${appointment.id}-h`' class='py-0 my-0'>Codes:</v-subheader>
          <div class='mr-3 text-xs-right'
            v-for='code in appointment.codes'
            :key='code.id' >
              <span class='mx-2' >{{code.icd10}}</span>
              <span class='mx-2'>{{code.process}}</span>
              <span class='ml-2'>{{formatCurrency(invoice.currency, code.price)}}</span>
          </div >
        </template>
        <!-- <v-list-group
          :key="`sub-${appointment.id}`"
          v-if="appointment.codes && appointment.codes.length > 0" >
          <v-subheader slot='activator' >Codes</v-subheader>
          <v-list-tile v-for='code in appointment.codes' :key='code.id' >
            <v-list-tile-content>
              <v-list-tile-title>{{code.icd10}}, {{code.process}}.
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action >
              {{code.price}}
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group> -->
      </template>
    </v-list-group>
  </v-list>
  <v-divider></v-divider>
  <v-card-actions >
    <v-btn @click='$emit("view", invoice)' flat >View <v-icon class='pl-1' >open_in_new</v-icon></v-btn>
    <v-btn @click='$emit("send", invoice)' flat>Send <v-icon class='pl-1' >send</v-icon></v-btn>
    <v-spacer></v-spacer>
    <v-btn @click='$emit("edit", invoice)' flat>More <v-icon>chevron_right</v-icon></v-btn>
  </v-card-actions>
  <v-footer class='pl-2' >
    #{{invoice.id}}
  </v-footer>
</v-card>
</template>

<script>
export default {
  name: 'InvoicePreview',
  props: {
    invoice: { type: Object }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Preview.vue?2a644667